import React from 'react';
import { Box } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import {
  useElementListColumnResizeHandle,
  ELEMENT_LIST_RESIZE_HANDLE_CLASS,
  ELEMENT_LIST_WIDTH_CSS,
} from '@features/proposals/ElementListRow/element-list-column-resize.hook';
import { ELEMENT_LIST_FOOTER_HEIGHT } from './element-list.constants';

const ElementListFooter: React.FC = () => {
  const { classes } = useStyles();
  const handleDragStart = useElementListColumnResizeHandle();

  return (
    // `flexShrink: 0` because the overscroll room below the list is sized
    // assuming this footer contributes its full height (DEV-3423); letting it
    // shrink would silently invalidate that.
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        flexShrink: 0,
        height: ELEMENT_LIST_FOOTER_HEIGHT,
        width: '100%',
      }}
    >
      <Box
        className={classes.leftColumn}
        sx={{
          position: 'relative',
          display: 'flex',
          alignItems: 'center',
          flexShrink: 0,
          height: '100%',
          width: ELEMENT_LIST_WIDTH_CSS,
          overflow: 'hidden',
        }}
      >
        {/* Drag handle */}
        <Box
          className={ELEMENT_LIST_RESIZE_HANDLE_CLASS}
          onMouseDown={handleDragStart}
          sx={{
            position: 'absolute',
            right: 0,
            top: 0,
            bottom: 0,
            width: 4,
            cursor: 'ew-resize',
          }}
        />
      </Box>

      <Box
        sx={{
          flex: 1,
          height: '100%',
          backgroundColor: 'warmSurface.main',
        }}
      />
    </Box>
  );
};

export default ElementListFooter;

const useStyles = makeStyles()(({ palette }) => ({
  leftColumn: {
    backgroundColor: palette.warmSurface.main,
    boxShadow: 'inset -1px 0 0 rgba(0,0,0,0.1)',
  },
}));
